import React from 'react';

import { withEventScope } from '@repo/event-processor';
import { Spacer } from '@repo/ui/components/Spacer';
import { Tag } from '@repo/ui/components/Tag';
import { H5 } from '@repo/ui/components/Typography';
import upperFirst from 'lodash/upperFirst';

import { TagsList } from './styles';
import { TagsProps } from './types';

const titleCase = (string: string) =>
  string.split(' ').map(upperFirst).join(' ');

/**
 * render the tags of a post
 */
const Tags = ({ tags, desktopGap, mobileGap }: TagsProps) => {
  if (!tags?.length) {
    return null;
  }

  return (
    <div>
      <H5>Tags</H5>
      <Spacer height="12px" />
      <TagsList
        desktopGap={desktopGap ?? '12px'}
        mobileGap={mobileGap ?? '8px'}
      >
        {tags.map(({ id, name }) => (
          <Tag key={id} text={titleCase(name)} />
        ))}
      </TagsList>
    </div>
  );
};

export default withEventScope(Tags, { module: 'designPostTags' });
